export default {
  props: {
    detail: {
      type: Object,
      default: () => {}
    },
    typeInfo: {},
  }
}